import { render, staticRenderFns } from "./StaffTrial.vue?vue&type=template&id=4e2cfa68&scoped=true"
import script from "./StaffTrial.vue?vue&type=script&lang=js"
export * from "./StaffTrial.vue?vue&type=script&lang=js"
import style0 from "./StaffTrial.vue?vue&type=style&index=0&id=4e2cfa68&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2cfa68",
  null
  
)

export default component.exports